import {Observable} from 'rxjs';
import {map, retry} from 'rxjs/operators';
import {CategoryModel, ContestantsCountryCount} from '@/models/category.model';
import {ChallengeModel} from '@/models/challenge.model';
import {BaseApi} from '@/api/base.api';
import {axiosInstance} from '@/api/axios.config.api';

export interface HomeCategoriesResponse {
  id: number;
  name: string;
  icon: string;
  slug: string;
  active?: boolean;
  contestants_country_count?: ContestantsCountryCount[];
}

export class CategoriesApi extends BaseApi<CategoryModel> {
  constructor() {
    super('challenge-categories', [])
  }

  actives(): Observable<ChallengeModel[]> {
    return axiosInstance().get<ChallengeModel[]>(`${this.url}/active`)
      .pipe(
        retry(1),
        map((response) => response.data),
      )
  }

  getChallenges(categoryId: number, params?: string): Observable<ChallengeModel[]> {
    let url = `${this.url}/${categoryId}/challenges`;
    if (params) {
      url += `?filter[all]=${params}`
    }
    return axiosInstance
    ().get<{ data: ChallengeModel[] }>(url)
      .pipe(
        retry(1),
        map((response) => response.data.data),
      )
  }

  getHomeData(): Observable<ContestantsCountryCount> {
    return axiosInstance
    ().get<ContestantsCountryCount>(this.url)
      .pipe(
        retry(1),
        map((response) => response.data),
      )
  }
}
